module.exports = __webpack_public_path__ + "assets/img/info-btn-84dede89.png";